export const AcceleratorsMetaDescription =
  "Fully documented reference applications for assembling Notecard- and Notehub-powered solutions.";
